import React from 'react';
import { useHistory } from 'react-router';
import usePermissions from 'hooks/permissions-hooks';
import { useDialog } from 'dialog-provider-hooks';
import actions from 'roles-actions-permissions/actions';
import AppTable from '../../basic/AppTable';
import { thematicPackageStatuses } from '../../../cassandra-shared-js/thematic-package-statuses';
import { useItems } from '../../../hooks/atoms/items-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';

const tableColumns = [
  { id: 1, label: 'ID', field: 'id' },
  { id: 2, label: 'Name', field: 'name' },
  { id: 3, label: 'Description', field: 'description' },
  { id: 4, label: 'Code', field: 'prod_code' },
  { id: 5, label: 'Status', field: 'roadmap_status' },
];

const ThematicPackageTable = () => {
  const { hasPermissions } = usePermissions();

  const history = useHistory();

  const {
    items: thematicPackages,
    itemsLoading: thematicPackagesLoading,
    itemsError: thematicPackagesError,
    pagination,
    deleteItem,
  } = useItems(CollectionKeys.THEMATIC_PACKAGES);

  const { openDialog } = useDialog();

  const handleViewAction = (event, id) => {
    history.push({
      pathname: '/thematic',
      search: `?id=${ id }`,
    });
  };

  const handleEditAction = (event, id) => {
    return id;
  };

  const openDeleteThematicDialog = (id) => {
    openDialog({
      title: 'Delete Thematic Package?',
      body() {
        return (<p>Are you sure you want to delete Thematic Package</p>);
      },
      onSubmit() {
        deleteItem(id);
      },
    });
  };

  const handleDelAction = (event, id) => {
    openDeleteThematicDialog(id);
    return id;
  };

  if (thematicPackagesError) {
    return (
      <span>
        Error:
        {thematicPackagesError.message}
      </span>
    );
  }

  return (
    <AppTable
      columns={ tableColumns }
      paginationProps={ pagination }
      loading={ thematicPackagesLoading }
      data={ thematicPackages?.map((tp) => {
        return {
          ...tp,
          roadmap_status: thematicPackageStatuses.find((s) => { return s.tag === tp.roadmap_status; })?.name,
        };
      }) }
      ViewProp={ { handleView: handleViewAction, disabledView: !hasPermissions(actions.VIEW_THEMATIC_PACKAGE) } }
      EditProp={ { handleEdit: handleEditAction, disabledEdit: !hasPermissions(actions.EDIT_THEMATIC_PACKAGE) } }
      DelProp={ { handleDelete: handleDelAction, disabledDelete: !hasPermissions(actions.DELETE_THEMATIC_PACKAGE) } }
    />
  );
};

export default ThematicPackageTable;
